/**
 * Behaviour for the shared date filter bar (App\Controls\DateRangeFilterControl):
 * an „Období" preset menu and separate Od / Do fields, each with its own
 * single-date picker. Picking a date, typing one or choosing a preset applies
 * immediately — there is no Filtrovat button.
 *
 * Design notes — these are the bugs this module exists to not repeat:
 *
 *  - Click/change handlers are delegated on `document` and registered exactly
 *    once, at bundle parse time. Redrawing the control's snippet swaps the markup
 *    underneath them; it can neither drop nor duplicate a handler.
 *    (The picker's own apply event is the exception — it does not bubble to
 *    document, so it is bound per-input in init().)
 *  - Preset dates come from PHP via data attributes. Nothing here recomputes
 *    "yesterday" or "the current week", so the menu and the server can never
 *    disagree.
 *  - The fields are the state: the request always sends both fields as shown, and
 *    the server answers with the redrawn bar (or a flash + snap-back on an invalid
 *    or too long range). An empty field is an open end.
 *  - Request parameters go through jQuery's data serialisation, so a value can
 *    never break out of the URL.
 */
(function (window, $) {
    "use strict";

    if (typeof $ !== "function" || !$.fn || !$.fn.daterangepicker) {
        return;
    }

    var SEL = {
        root: ".js-date-range-filter",
        preset: ".js-drf-preset",
        input: ".js-drf-input",
        from: ".js-drf-from",
        to: ".js-drf-to",
        reset: ".js-drf-reset",
    };

    var ISO = "YYYY-MM-DD";
    var DISPLAY = "DD.MM.YYYY";
    var READY = "drfReady";

    var initialized = false;

    /**
     * Creates the pickers for every field that does not have one yet. Safe to call
     * as often as you like — after a snippet redraw the element is brand new and
     * therefore unflagged, everything else is skipped.
     */
    function init() {
        $(SEL.root).each(function () {
            var $root = $(this);

            // Nette's unique component id — stable across redraws, always [\w-].
            var id = ($root.attr("data-drf-id") || "").replace(/[^\w-]/g, "");

            $root.find(SEL.input).each(function (index) {
                var $input = $(this);

                if ($input.data(READY)) {
                    return;
                }

                // The popup lives in <body>, so a snippet redraw of the bar leaves it
                // behind, detached from any input. Drop the stale one before rebuilding.
                var owner = id + "-" + index;
                if (id) {
                    $('.daterangepicker[data-drf-owner="' + owner + '"]').remove();
                }

                var options = {
                    singleDatePicker: true,
                    autoApply: true,
                    autoUpdateInput: false,
                    showDropdowns: true,
                    locale: $.extend({ format: DISPLAY, firstDay: 1 }, $root.data("drfLocale") || {}),
                };

                var current = window.moment($input.val(), DISPLAY, true);
                if (current.isValid()) {
                    options.startDate = current;
                }

                $input.daterangepicker(options);
                $input.data(READY, true);

                var picker = $input.data("daterangepicker");
                if (id && picker && picker.container) {
                    picker.container.attr("data-drf-owner", owner);
                }

                // Bound directly, not delegated on document: daterangepicker's apply
                // event does not reach document. The READY flag means we only get here
                // once per input element, and a redraw replaces the element.
                $input.on("apply.daterangepicker", function (e, p) {
                    $input.val(p.startDate.format(DISPLAY));
                    apply($root);
                });
            });
        });
    }

    /** The field value as ISO, "" for an empty field, or the raw text when it is not a date (the server rejects it). */
    function fieldValue($root, selector) {
        var raw = $.trim($root.find(selector).val() || "");
        if (raw === "") {
            return "";
        }

        var date = window.moment(raw, ["D.M.YYYY", DISPLAY], true);
        return date.isValid() ? date.format(ISO) : raw;
    }

    function apply($root) {
        send($root.attr("data-drf-apply"), {
            from: fieldValue($root, SEL.from),
            to: fieldValue($root, SEL.to),
        });
    }

    /**
     * Hands the range to the control's signal. The response carries the redrawn
     * snippets, so there is nothing to do on success — the bar, the flash message
     * and whatever the consumer redraws in onChange all arrive together.
     */
    function send(url, data) {
        if (!url || !$.nette) {
            return;
        }

        $.nette.ajax({
            url: url,
            method: "POST",
            data: data || {},
        });
    }

    function bind() {
        if (initialized) {
            return;
        }
        initialized = true;

        var $document = $(document);

        $document.on("click", SEL.preset, function () {
            var $button = $(this);
            var $root = $button.closest(SEL.root);
            var from = $button.attr("data-drf-from");
            var to = $button.attr("data-drf-to");

            if (!from || !to) {
                return;
            }

            $root.find(SEL.from).val(window.moment(from, ISO).format(DISPLAY));
            $root.find(SEL.to).val(window.moment(to, ISO).format(DISPLAY));
            send($root.attr("data-drf-apply"), { from: from, to: to });
        });

        // Typed dates (and a cleared field) apply on change — blur or Enter.
        $document.on("change", SEL.input, function () {
            apply($(this).closest(SEL.root));
        });

        $document.on("keydown", SEL.input, function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                $(this).trigger("blur");
            }
        });

        $document.on("click", SEL.reset, function () {
            $(this).blur();
            send($(this).closest(SEL.root).attr("data-drf-reset"));
        });

        // Every nette-ajax response may have swapped the bar's markup; jQuery fires
        // ajaxComplete after nette's snippet handler has already run.
        $document.ajaxComplete(init);

        $(init);
    }

    bind();

    window.dateRangeFilter = { init: init };
})(window, window.jQuery);
